import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { useInterval } from '@tsl-frontend/tsl-utilities';

import {
    currentSessionStarting,
    currSessionPlannedAtSelector,
    currSessionToEndAtSelector,
    nextLessonSelector,
} from '@store/session';

import { useAppDispatch } from '@store';
import { currentProgrammeSelector } from '@store/programme';
import { ONE_MINUTE_MS, THREE_MINUTES_MS } from '@consts';

const useStartSession = () => {
    const dispatch = useAppDispatch();

    const sessionPlannedAt = useSelector(currSessionPlannedAtSelector);
    const sessionToEndAt = useSelector(currSessionToEndAtSelector);
    const currentProgramme = useSelector(currentProgrammeSelector);
    const nextLesson = useSelector(nextLessonSelector);

    const [showStartSession, setShowStartSession] = useState(false);

    const validNextSession = currentProgramme && nextLesson && sessionPlannedAt;

    const checkShowSession = () => {
        // only run if there is a current session loaded
        if (validNextSession && sessionToEndAt) {
            const currentTime = dayjs().utc();
            const timeUntilSessionMS = sessionPlannedAt.diff(currentTime);

            const isPreSession =
                currentTime.isBefore(sessionPlannedAt) &&
                timeUntilSessionMS < THREE_MINUTES_MS;
            const isActiveSession =
                currentTime.isAfter(sessionPlannedAt) &&
                currentTime.isBefore(sessionToEndAt);
            const startSession = isPreSession || isActiveSession;
            setShowStartSession(startSession);

            dispatch(currentSessionStarting(startSession));
        }
    };

    useEffect(checkShowSession, [
        dispatch,
        nextLesson,
        validNextSession,
        sessionPlannedAt,
        sessionToEndAt,
    ]);
    useInterval(checkShowSession, validNextSession ? ONE_MINUTE_MS : undefined);

    return showStartSession;
};

export default useStartSession;
